import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {CodeRepository} from "../types.ts";
import {I18n} from "@aws-amplify/core";


export const useCodeRepositoriesTableColumns = () => {

    const columns: DataTableColumn<CodeRepository>[] = [
        {
            accessor: 'name',
            sortable: true,
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: CodeRepository) => <NavLink to={`/code-repositories/${item.name}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'provider',
            sortable: true,
            title: I18n.get('Provider'),
            width: '1fr',
            render: (item: CodeRepository) => item.provider,
        },
        {
            accessor: 'description',
            sortable: true,
            title: I18n.get('Description'),
            width: '2fr',
            render: (item: CodeRepository) => item.description,
        },
        {
            accessor: 'defaultBranch',
            sortable: true,
            title: I18n.get('Default Branch'),
            width: '1fr',
            render: (item: CodeRepository) => item.defaultBranch,
        },
    ];

    return {
        columns,
    };
};
